/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
export var Locale;
(function (Locale) {
    Locale["EN"] = "EN";
    Locale["EN_US"] = "en_US";
    Locale["FR_FR"] = "fr_FR";
    Locale["IT_IT"] = "it_IT";
    Locale["ES_ES"] = "es_ES";
})(Locale || (Locale = {}));
